// TODO: Import this correctly: https://github.com/orestbida/cookieconsent/issues/441

// Categories ['necessary', 'analytics', 'marketing']

const COOKIEDEBUG = false;
if (COOKIEDEBUG) console.log("Cookie Debug mode turned on")

// table for all the cookies
const direct_cookie_table = {
    analytics: [             // list of all expected cookies
        {
            col1: '^_ga',       // match all cookies starting with "_ga"
            col2: 'google.com',
            col3: '1 year',
            col4: 'Google Analytics Tracking',
            is_regex: true
        },
        {
            col1: '_gid',
            col2: 'google.com',
            col3: '1 year',
            col4: 'description ...',
        },
        {
            col1: '^__insp',
            col2: 'inspectlet.com',
            col3: '1 year',
            col4: 'description ...',
            is_regex: true
        },
    ],
    marketing: [             // list of all expected cookies
        {
            col1: '^_fbp',
            col2: 'facebook.com',
            col3: '1 year',
            col4: 'Description ...',
            is_regex: true
        },
        {
            col1: '^__Secure',
            col2: 'Google.com',
            col3: '1 year',
            col4: 'Google Ads...',
            is_regex: true
        },
        {
            col1: '_clsk',
            col2: 'clarity.ms',
            col3: '1 year',
            col4: 'Microsoft',
        },
        {
            col1: '_uetvid',
            col2: 'bing.com',
            col3: '1 year',
            col4: 'description ...',
        },
        {
            col1: 'NID',
            col2: 'google.com',
            col3: '1 year',
            col4: 'Google Ads',
        },
        {
            col1: 'OTZ',
            col2: 'google.com',
            col3: '1 year',
            col4: 'Google Ads',
        },
        {
            col1: 'AEC',
            col2: 'google.com',
            col3: '1 year',
            col4: 'Google Ads',
        },
        {
            col1: '1P_JAR',
            col2: 'google.com',
            col3: '1 year',
            col4: 'Google Ads',
        },
        {
            col1: 'DV',
            col2: 'google.com',
            col3: '1 year',
            col4: 'Google Ads',
        },
    ]
}

const removeElementFromDOM = (element) => {
    const target = document.querySelector(element);
    if (target) {
        target.remove();
    }
}

const getCookie = (name) => {
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? match[1] : null;
}

const eraseRegexCookies = (theCookie, path, domain) => {
    let arrSplit = document.cookie.split(";");

    for( let i = 0; i < arrSplit.length; i++)  {
        const cookie = arrSplit[i].trim();
        const cookieName = cookie.split("=")[0];

        // If the prefix of the cookie's name matches the one specified, remove it
        if(cookieName.indexOf(theCookie) === 0) {

            if (COOKIEDEBUG) console.log(`${cookieName} has been deleted!`)
            // Remove the cookie
            document.cookie = `${cookieName}=; path=${path}; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        }
    }
}

// configuration file to set up cookieconsent
// https://github.com/orestbida/cookieconsent/tree/v2.8
const cc_config = {
    current_lang: 'en',
    autoclear_cookies: false,                   // default: false
    page_scripts: true,                        // default: false

    mode: 'opt-out',                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
    delay: 0,                               // default: 0
    // auto_language: null                     // default: null; could also be 'browser' or 'document'
    // autorun: true,                          // default: true
    // force_consent: false,                   // default: false
    // hide_from_bots: false,                  // default: false
    // remove_cookie_tables: false             // default: false
    cookie_name: 'cookie_consent',               // default: 'cc_cookie'
    // cookie_expiration: 182,                 // default: 182 (days)
    // cookie_necessary_only_expiration: 182   // default: disabled
    // cookie_domain: location.hostname,       // default: current domain
    // cookie_path: '/',                       // default: root
    // cookie_same_site: 'Lax',                // default: 'Lax'
    // use_rfc_cookie: false,                  // default: false

    // any changes to this must bump the revision to clear everything
    // revision: 0,                            // default: 0

    onFirstAction: function (user_preferences, cookie) {
        // callback triggered only once
    },

    // NOTE: This is more `onEvent`. It always fires
    onAccept: function (cookie) {
        // disable popup
        removeElementFromDOM('#consent-popup');

        // initialize GTM layer
        window.dataLayer = window.dataLayer || []
        const categories = cookie.categories;

        // If consent Approves
        if (categories.includes('analytics') && categories.includes('marketing')) {
            if (COOKIEDEBUG) console.log("User Approves")
            dataLayer.push('consent', 'update', {
                'ad_storage': 'granted',
                'analytics_storage': 'granted',
                'functionality_storage': 'granted',
                'personalization_storage': 'granted',
                'security_storage': 'granted'
            });


        } else {
            if (COOKIEDEBUG) console.log("User Rejects")

            /**
             * Aggressively purge all the cookies as a protection measure.
             */
            const domains = [location.hostname, `.${location.hostname.replace('www.','')}`, '.com', 'com', '.com.test', '.com.devel', '.google.com']

            const cookies_direct = ['_gid', '_ga', '_uetsid', '_uetvid', 'ln_or', 'NID', 'OTZ', 'AEC', '1P_JAR', 'DV', '__insp_targlpt', '__insp_slim', '__insp_nv', '__insp_norec_sess', '__insp_targlpu', '_fbp', '__insp_wid'];
            const cookies_regex = ['_ga', '_gat', '_uet',  '_ga_', '_gcl', '__insp', '_fb', '_rdt']

            const cookiesToErase = [...cookies_direct, ...cookies_regex];

            domains.forEach(domain => {
                if (COOKIEDEBUG) console.groupCollapsed();
                if (COOKIEDEBUG) console.log(`${domain} - erasing domain`)
                cc.eraseCookies(cookiesToErase, '/', domain);

                // regex scrub
                cookiesToErase.forEach(cookie => {
                    eraseRegexCookies(cookie, '/', domain);
                })
                if (COOKIEDEBUG) console.groupEnd();
            });

        }
    },

    onChange: function (cookie, changed_preferences) {

    },
    languages: {
        'en': {
            // We are not using the consent modal and using our own div
            consent_modal: {
                title: 'We use cookies!',
                description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
                primary_btn: {
                    text: 'Accept all',
                    role: 'accept_all'              // 'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: 'Reject all',
                    role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                }
            },

            // We are not using the settings modal at this time.
            settings_modal: {
                title: 'Cookie preferences',
                save_settings_btn: 'Save settings',
                accept_all_btn: 'Accept all',
                reject_all_btn: 'Reject all',
                close_btn_label: 'Close',
                cookie_table_headers: [
                    {col1: 'Name'},
                    {col2: 'Domain'},
                    {col3: 'Expiration'},
                    {col4: 'Description'}
                ],
                blocks: [
                    {
                        title: 'Cookie usage 📢',
                        description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.'
                    }, {
                        title: 'Strictly necessary cookies',
                        description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                        }
                    }, {
                        title: 'Performance and Analytics cookies',
                        description: 'These cookies allow the website to remember the choices you have made in the past',
                        toggle: {
                            value: 'analytics',     // your cookie category
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: direct_cookie_table.analytics
                    }, {
                        title: 'Advertisement and Marketing cookies',
                        description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                        toggle: {
                            value: 'marketing',
                            enabled: false,
                            readonly: false
                        },
                        cookie_table: direct_cookie_table.marketing
                    }, {
                        title: 'More information',
                        description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="#yourcontactpage">contact us</a>.',
                    }
                ]
            }
        }
    }
}
let cc = initCookieConsent();

window.onload = () => {

    const delayTime = 3000;
    setTimeout(() => {
        // 1 - Initiate Cookie Consent
        cc.run(cc_config);

        // 2 - Does cookie exist
        if (!cc.validCookie('cookie_consent')) {
            if (COOKIEDEBUG) console.log("Cookie consent exists - hide prompt");
            const consentPopup = document.querySelector('#consent-popup');
            consentPopup.classList.remove('hide');
            consentPopup.classList.add('show');
        }

        // 3 - delete the original element
        removeElementFromDOM('#cc_div');

    }, delayTime)

}